module.exports = __webpack_public_path__ + "img/h.fd6d5b79.jpg";